import { HttpRequestEntity } from 'shared/domain/httpRequest/httpRequestModel';
import { LevelInDto } from 'shared/dtos/in/level';
import {
  broadcastUploadedLevelError,
  broadcastUploadedLevel,
  broadcastDeletedLevel,
  broadcastUpdatedLevels,
} from 'serviceWorker/broadcasts/levels';
import { chooseErrorMessage } from 'shared/utils/errorHandling';
import { neverReached } from 'shared/utils/neverReached';

export function broadcastLevelResponse(
  request: HttpRequestEntity,
  response: any
): void {
  if (response.error) {
    const messageId = chooseErrorMessage(response.error);
    return broadcastUploadedLevelError(response.error, messageId, request.data.uniqueId);
  }

  switch (request.method) {
    case 'POST':
    case 'GET':
      return broadcastUploadedLevel(response, request.data.uniqueId);
    case 'DELETE':
      return broadcastDeletedLevel(response, request.data.uniqueId);
    case 'PUT':
      return broadcastUpdatedLevels(
        response.map((level: LevelInDto) => level._id),
        request.data.uniqueId
      );
    default:
      neverReached(request.method);
  }
}
